var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpeSplashImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1080px",
    height: "490px",
    viewBox: "0 0 1080 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e7e7e7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.94796,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    width: 1080,
    height: 490,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d8d8d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.98205,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 355.79831,
    cy: 350.73657,
    r: 63.086079
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d8d8d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.98205,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 539.54779,
    cy: 350.73657,
    r: 63.086079
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d8d8d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.98205,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 723.29736,
    cy: 350.73657,
    r: 63.086079
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 538.83014,201.13038 v 89.26991"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 723.27317,289.7597 -0.0932,-45.20812 -366.40861,-0.58128 0.10474,45.08993"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.98205,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 539.54779,
    cy: 139.25662,
    r: 63.086079
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpeSplashImage);
export default __webpack_public_path__ + "static/media/UpeSplashImage.78ac2302fd34fc81a618e0047f1e4c84.svg";
export { ForwardRef as ReactComponent };